// extracted by mini-css-extract-plugin
export var bodySections = "_8l-8";
export var gray = "_8l-7";
export var green = "_8l-4";
export var iconContainer = "_8l-9";
export var iconWidgetContainer = "_8l-1";
export var phoneIcon = "_8l-2";
export var red = "_8l-5";
export var statusDot = "_8l-3";
export var widgetContainer = "_8l-0";
export var yellow = "_8l-6";